module.exports = __webpack_public_path__ + "static/media/logo.f4d4f18f.png";